import Link from 'next/link';
import { useTranslations } from 'next-intl';

import PinIcon from '@/fo/icons/base/icons/pin-map.svg';
import PinActiveIcon from '@/fo/icons/base/icons/pin-map_active.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { useMediaQuery } from '@/fo/ui/mod/media/query';
import { utilFormatPhoneNumber } from '@/fo/util/format-phone-number';

import { PointFeature } from '../../types';

import { styles } from './Marker.styles';
interface MarkerProps {
  feature: PointFeature;
  onClick: (feature: PointFeature) => void;
  isSelected: boolean;
  selectedCity?: string;
}

export function Marker({
  feature,
  onClick,
  isSelected,
  selectedCity
}: MarkerProps) {
  const slots = styles({ isSelected });
  const t = useTranslations();
  const isDesktop = useMediaQuery('lg');
  const handleClick = () => {
    onClick(feature);
  };
  const mapLink = `http://maps.yandex.ru/?pt=${feature.geometry.coordinates[0]},${feature.geometry.coordinates[1]}&z=18&l=map`;

  return (
    <button
      className={slots.marker()}
      onClick={handleClick}
    >
      {!isSelected && <PinIcon />}
      {isSelected && <PinActiveIcon />}
      {isSelected && isDesktop && (
        <div className={slots.popup()}>
          <p className={slots.title()}>{feature.properties.title}</p>
          <p className={slots.address()}>{feature.properties.address}</p>
          {feature.properties.work_time && (
            <p className={slots.worktime()}>{feature.properties.work_time}</p>
          )}
          <Link
            className={slots.phone()}
            href={`tel:${feature.properties.phone}`}
          >
            {utilFormatPhoneNumber(feature.properties.phone || '')}
          </Link>
          {!selectedCity && (
            <UiKitButtonBase
              color="secondary"
              as="link"
              href={mapLink}
              target="_blank"
              className={slots.button()}
            >
              {t('Get direction')}
            </UiKitButtonBase>
          )}
          {selectedCity && (
            <p className={slots.stock()}>
              {t(feature.properties.in_stock ? 'In stock' : 'Out of stock')}
            </p>
          )}
        </div>
      )}
    </button>
  );
}
